import Dict from '@/utils/dict-utils'

// 用户状态
export const userStatusDict = new Dict({
  NORMAL: { value: 1, label: '正常' },
  FORBIDDEN: { value: 0, label: '禁用' }
})

// 是否为默认密码
export const isDefaultPasswordDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 是否为平台老帐号
export const isOldAccountDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 员工的状态
export const employeeStatusDict = new Dict({
  NORMAL: { value: 1, label: '正常', type: 'primary' },
  FORBIDDEN: { value: 0, label: '禁用', type: 'danger' }
})

// 商城、商户员工状态
export const mallEmployeeStatusDict = new Dict({
  NORMAL: { value: 1, label: '正常', type: 'primary' },
  FORBIDDEN: { value: 2, label: '禁用', type: 'danger' }
})
